import React, { useState } from 'react';
import { ConnectedViewTeamMembers } from 'src/web/containers/InstitutionAdminSettings/TeamPage/ViewTeamMembers/connector';
import { ConnectedAddMember } from '../components/AddMember/connector';
import { StyledTabPane, StyledTabs } from '../styles';

enum NavStateEnum {
  VIEW_MEMBER = 'VIEW_MEMBER',
  ADD_MEMBER = 'ADD_MEMBER',
  MANAGE_COURSE = 'MANAGE_COURSE',
}

export const TeamPage: React.FC = () => {
  const [navState, setNavState] = useState<NavStateEnum>(
    NavStateEnum.VIEW_MEMBER
  );
  return (
    <>
      <StyledTabs
        activeKey={navState}
        onChange={(key) => setNavState(key as NavStateEnum)}
      >
        <StyledTabPane tab="View team members" key={NavStateEnum.VIEW_MEMBER}>
          <ConnectedViewTeamMembers />
        </StyledTabPane>
        <StyledTabPane tab="Add team members" key={NavStateEnum.ADD_MEMBER}>
          <ConnectedAddMember memberType="team members" />
        </StyledTabPane>
      </StyledTabs>
    </>
  );
};
